import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_BANNER_LISTING,
    ADD_BANNER,
    UPDATE_BANNER,
    DELETE_BANNER,
    EXPORT_BANNER,
    GET_BANNER_DETAILS,
} from "./actionTypes.js";

import {
    getBannerListingSuccess,
    getBannerListingFail,
    createBannerSuccess,
    createBannerFail,
    updateBannerSuccess,
    updateBannerFail,
    deleteBannerSuccess,
    deleteBannerFail,
    exportBannerSuccess,
    exportBannerFail,
    getBannerDetailsSuccess,
    getBannerDetailsFail,
} from "./actions.js";

import {
    bannerListingApi,
    bannerDetailsApi,
    addBannerApi,
    updateBannerApi,
    deleteBannerApi,
    exportBannerApi,
} from "./bannerApi.js";

function* fetchBannerListing({ payload }) {
    try {
        const response = yield call(bannerListingApi, payload);
        yield put(getBannerListingSuccess(response));
    } catch (error) {
        yield put(getBannerListingFail(error));
    }
}

function* fetchBannerDetail({ payload }) {
    try {
        const response = yield call(bannerDetailsApi, payload);
        yield put(getBannerDetailsSuccess(response));
    } catch (error) {
        yield put(getBannerDetailsFail(error));
    }
}

function* createBanner({ payload }) {
    try {
        const response = yield call(addBannerApi, payload);
        yield put(createBannerSuccess(response));
    } catch (error) {
        yield put(createBannerFail(error));
    }
}

function* updateBanner({ payload }) {
    try {
        const response = yield call(updateBannerApi, payload);
        yield put(updateBannerSuccess(response));
    } catch (error) {
        yield put(updateBannerFail(error));
    }
}

function* deleteBanner({ payload }) {
    try {
        const response = yield call(deleteBannerApi, payload);
        yield put(deleteBannerSuccess(response));
    } catch (error) {
        yield put(deleteBannerFail(error));
    }
}

function* exportBanner({ payload }) {
    try {
        const response = yield call(exportBannerApi, payload);
        yield put(exportBannerSuccess(response));
    } catch (error) {
        yield put(exportBannerFail(error));
    }
}

function* BannerSaga() {
    yield takeEvery(GET_BANNER_LISTING, fetchBannerListing);
    yield takeEvery(GET_BANNER_DETAILS, fetchBannerDetail);
    yield takeEvery(ADD_BANNER, createBanner);
    yield takeEvery(UPDATE_BANNER, updateBanner);
    yield takeEvery(DELETE_BANNER, deleteBanner);
    yield takeEvery(EXPORT_BANNER, exportBanner);

}

export default BannerSaga
